import { FC } from "react";
import { useNavigate, useParams } from "react-router-dom";

import DocumentUpload from "src/components/documentUpload";
import FooterText from "../../components/footerText";
import AuthSubHeader from "src/components/authSubHeader";



const Document: FC = (): JSX.Element => {
  const { caseId } = useParams();
  const navigate = useNavigate()

  return (
    <div className="cases-page body-bg overflow-y-auto overflow-x-hidden d-flex flex-column flex-fill">
      <div className="container px-4 pt-2">
        <AuthSubHeader />
        <DocumentUpload 
          caseId={caseId ? Number(caseId) : 0} caseDocuments={[]} title="Upload Clinical Document" 
          setNotes={() => navigate("/cases")}
        />
        <div className="bg-white mt-3"><FooterText footerType="black"/></div>
      </div>
    </div>
  );
};

export default Document;
